module.exports = __webpack_public_path__ + "static/media/logo-white-transparent.b4ac4703.gif";